export default __webpack_public_path__ + "static/media/table.bc1696b5.svg";